import React, { useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import EditUserPhoneEmailOTPSent from './EditUserPhoneEmailOTPSent';
import EditUserPhoneEnterEmailOTP from './EditUserPhoneEnterEmailOTP';
import EditUserPhoneEnterNewMobileOTP from './EditUserPhoneEnterNewMobileOTP';
import EditUserPhoneEnterNewPhone from './EditUserPhoneEnterNewPhone';
import EditUserPhoneNewPhoneOTPSent from './EditUserPhoneNewPhoneOTPSent';
import EditUserPhoneSuccess from './EditUserPhoneSuccess';

type Props = {
  /**
   * Invoked when editing is successful.
   * Automatically invoked in 3 seconds after successful update.
   */
  onSuccess?: () => void;
};

const EditUserPhone = (props: Props) => {
  const [stepCounter, setStepCounter] = useState(0);
  const [newPhoneNumber, setNewPhoneNumber] = useState('');

  return (
    <View
      style={style.root}
      {...Platform.select({ web: { accessibilityRole: 'form' } })}
    >
      {stepCounter === 0 && (
        <EditUserPhoneEnterNewPhone
          onSuccess={(phone) => {
            setNewPhoneNumber(phone);
            setStepCounter(1);
          }}
        />
      )}
      {stepCounter === 1 && (
        <EditUserPhoneEmailOTPSent
          onNextButtonPress={() => {
            setStepCounter(2);
          }}
        />
      )}
      {stepCounter === 2 && (
        <EditUserPhoneEnterEmailOTP
          phoneNumber={newPhoneNumber}
          onSuccess={() => {
            setStepCounter(3);
          }}
        />
      )}
      {stepCounter === 3 && (
        <EditUserPhoneNewPhoneOTPSent
          phoneNumber={newPhoneNumber}
          onSubmit={() => {
            setStepCounter(4);
          }}
        />
      )}
      {stepCounter === 4 && (
        <EditUserPhoneEnterNewMobileOTP
          phoneNumber={newPhoneNumber}
          onSuccess={() => {
            setStepCounter(5);
            setTimeout(() => props.onSuccess?.(), 3000);
          }}
        />
      )}
      {stepCounter === 5 && (
        <EditUserPhoneSuccess onSuccess={props.onSuccess} />
      )}
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
  },
});

export default EditUserPhone;
